import { Link } from "react-router-dom";
import { ProductCard } from "@/components/ProductCard";
import { ArrowRight } from "@phosphor-icons/react";

export function CategorySection({ category, products, index }) {
  if (!products.length) return null;
  return (
    <section
      id={`cat-${category.slug}`}
      data-testid={`home-category-section-${category.slug}`}
      className={`scroll-mt-24 ${index % 2 === 1 ? "bg-[#EADDC8]/25" : ""}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 sm:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6 sm:mb-10">
          <div className="flex items-center gap-5">
            <img src={category.image_url} alt={category.name} loading="lazy" className="hidden sm:block w-16 h-16 rounded-2xl object-cover" />
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-[#5B7B53] mb-1">Category · {products.length} picks</p>
              <h2 className="font-display text-3xl sm:text-4xl text-[#2C2B29]">{category.name}</h2>
              <p className="text-sm text-[#5C5A56] mt-1">{category.description}</p>
            </div>
          </div>
          <Link
            to={`/category/${encodeURIComponent(category.name)}`}
            data-testid={`home-category-see-all-${category.slug}`}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#D17A58] hover:gap-2.5 transition-[gap] duration-200 self-start md:self-auto"
          >
            See all {category.name} <ArrowRight size={14} weight="bold" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-sm:flex max-sm:overflow-x-auto max-sm:snap-x max-sm:snap-mandatory max-sm:scroll-px-6 max-sm:gap-4 max-sm:-mx-6 max-sm:px-6 max-sm:pb-2 hh-no-scrollbar" data-testid={`home-category-row-${category.slug}`}>
          {products.slice(0, 4).map((p) => (
            <div key={p.id} className="max-sm:snap-start max-sm:shrink-0 max-sm:w-[78%] flex">
              <ProductCard product={p} />
            </div>
          ))}
        </div>
        {products.length > 1 && <p className="sm:hidden text-xs text-[#5C5A56] mt-3">Swipe for more →</p>}
      </div>
    </section>
  );
}

export function CategoryChips({ categories }) {
  return (
    <nav data-testid="home-category-chips" className="flex gap-2 overflow-x-auto lg:flex-wrap lg:overflow-visible pb-1 -mx-6 px-6 lg:mx-0 lg:px-0 hh-no-scrollbar">
      {categories.map((c) => (
        <a
          key={c.id}
          href={`#cat-${c.slug}`}
          data-testid={`home-chip-${c.slug}`}
          className="shrink-0 rounded-full border border-[#E5E0D8] bg-white px-4 py-2.5 text-sm font-medium text-[#2C2B29] hover:border-[#5B7B53] hover:text-[#5B7B53] transition-colors"
        >
          {c.name}
        </a>
      ))}
    </nav>
  );
}
